var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2143 0H2.78571C1.24777 0 0 1.24777 0 2.78571V23.2143C0 24.7522 1.24777 26 2.78571 26H23.2143C24.7522 26 26 24.7522 26 23.2143V2.78571C26 1.24777 24.7522 0 23.2143 0ZM21.3571 14.625C21.3571 15.008 21.0437 15.3214 20.6607 15.3214H15.3214V20.6607C15.3214 21.0437 15.008 21.3571 14.625 21.3571H11.375C10.992 21.3571 10.6786 21.0437 10.6786 20.6607V15.3214H5.33929C4.95625 15.3214 4.64286 15.008 4.64286 14.625V11.375C4.64286 10.992 4.95625 10.6786 5.33929 10.6786H10.6786V5.33929C10.6786 4.95625 10.992 4.64286 11.375 4.64286H14.625C15.008 4.64286 15.3214 4.95625 15.3214 5.33929V10.6786H20.6607C21.0437 10.6786 21.3571 10.992 21.3571 11.375V14.625Z",
    fill: "#5F5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTicket);
export default __webpack_public_path__ + "static/media/new-ticket.e5eeeed1347fc680b5d7a87da95dbc9d.svg";
export { ForwardRef as ReactComponent };